export enum VideoStatus {
  READY = "READY",
  TRANSCRIBING = "TRANSCRIBING",
  TRANSCRIPT_READY = "TRANSCRIPT READY",
  FETCHING = "FETCHING",
  COMPRESSING = "COMPRESSING",
}

export interface VideoData {
  title: string;
  videoUrl: string;
  recordedOn: string;
  recordedBy?: string;
  uploadedOn: string;
  uploadedBy?: string;
  id: string;
  transcript: unknown;
  status: VideoStatus;
  fileType?: string;
}
